import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, l) {
  return e(), t("svg", n, [...l[0] || (l[0] = [
    o("path", {
      fill: "currentColor",
      d: "M12 3c4.418 0 8 3.297 8 7.363v4.91l-.001.04v2.414c0 1.751-1.494 3.181-3.372 3.27l-.183.004H12v-.818h4.444c1.473 0 2.666-1.1 2.666-2.456h.001v-.295q-.045.05-.093.1a3.6 3.6 0 0 1-1.873.95 4 4 0 0 1-.518.059l-.183.005h-1.778V12h4.444v-1.637c0-3.614-3.183-6.545-7.11-6.545s-7.111 2.93-7.111 6.545V12h4.444v6.546H7.556l-.184-.005a4 4 0 0 1-.645-.086l-.028-.006q-.15-.035-.296-.08l-.013-.004c-.07-.022-.138-.05-.206-.076q-.053-.018-.103-.038-.086-.037-.169-.08-.066-.029-.13-.064-.076-.04-.15-.085-.06-.034-.117-.07-.08-.054-.158-.111l-.103-.075q-.064-.051-.126-.106-.058-.049-.113-.1-.06-.056-.117-.117l-.101-.108q-.05-.057-.098-.118-.049-.06-.095-.121a3 3 0 0 1-.132-.195l-.026-.042a3 3 0 0 1-.124-.223l-.022-.047a3.1 3.1 0 0 1-.296-1.148L4 15.273v-4.91C4 6.297 7.582 3 12 3M4.889 15.273q0 .254.054.495c.25 1.118 1.324 1.96 2.613 1.96h.888v-4.91H4.89zm10.666 2.454h.89c.735 0 1.402-.274 1.884-.718q.112-.104.21-.22c.356-.418.571-.944.571-1.517v-2.454h-3.555z"
    }, null, -1)
  ])]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
